import { useState } from 'react';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Select, Stack, Text } from '@mantine/core';
import { useIntl } from 'react-intl';

import { ModalContent } from '../modal-content';
import { ModalFooter } from '../modal-footer';
import { FREIGHT_GET_HELP_REASONS } from './freight-get-help-reason-codes';
import { getHelpModalMessages } from './get-help-modal-messages';

import type { FreightGetHelpReasonCode } from './freight-get-help-reason-codes';
import type { GetHelpModalContentProps } from './get-help-modal-types';

export const GetHelpModalContent = ({
  onClose,
  reasonCodes,
  referenceLabel,
  referenceValue,
  isSubmitting,
  onSubmit,
  zIndex,
}: GetHelpModalContentProps) => {
  const intl = useIntl();
  const [reasonCode, setReasonCode] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (!reasonCode) return;
    const success = await onSubmit({ reasonCode: reasonCode as FreightGetHelpReasonCode });
    if (success) onClose();
  };

  const selectData = reasonCodes.map((code) => ({
    value: code,
    label: intl.formatMessage(FREIGHT_GET_HELP_REASONS[code].label),
  }));

  return (
    <>
      <ModalContent>
        <Stack gap={4}>
          <Text fw={600} size='sm'>
            {referenceLabel}
          </Text>
          <Text size='sm'>{referenceValue}</Text>
        </Stack>
        <Select
          comboboxProps={{ zIndex: (zIndex ?? 0) + 1 }}
          data={selectData}
          label={intl.formatMessage(getHelpModalMessages.reasonSelectLabel)}
          onChange={setReasonCode}
          placeholder={intl.formatMessage(getHelpModalMessages.reasonSelectPlaceholder)}
          value={reasonCode}
        />
      </ModalContent>
      <ModalFooter>
        <Button onClick={onClose} variant='ghost'>
          {intl.formatMessage(getHelpModalMessages.cancelButton)}
        </Button>
        <Button
          disabled={reasonCode === null}
          loading={isSubmitting}
          onClick={handleSubmit}
          rightSection={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          variant='primary'
        >
          {intl.formatMessage(getHelpModalMessages.continueButton)}
        </Button>
      </ModalFooter>
    </>
  );
};
